import { connect } from 'react-redux'
import { updateConfigFilters } from '../utils/actions/spotBiddingConfigList'
import { SpotBiddingConfigFilter } from './SpotBiddingConfigFilter'

export const SpotBiddingConfigFilterContainer = connect(
  ({
    spotBiddingConfigList: {
      params: { filters },
    },
  }) => ({ filters }),
  dispatch => ({
    updateConfigFilters: filters => dispatch(updateConfigFilters(filters)),
  })
)(SpotBiddingConfigFilter)
